import { FunnelStateKey } from './funnel-state-key';

export const PRAXIA_FAST_TRACK_STEPS_TO_REMOVE = [
  FunnelStateKey.WantFromEmployers,
  FunnelStateKey.ShiftSystem,
  FunnelStateKey.DocumentationSystems,
  FunnelStateKey.PermanentOrTemporary,
];
